// Porta da rota /carteira: quem não tem acesso volta para o dashboard em vez de
// abrir a tela e receber 403 da API. O bloqueio de verdade é no backend — este
// componente só evita mostrar um erro para quem só errou o link.

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-hook';
import { podeAcessarCarteira } from './carteira-acesso';

export function CarteiraRoute({ children }: { children: ReactNode }) {
  const { user, isAdmin, loading } = useAuth();

  // Enquanto a sessão não resolveu, o squad ainda é desconhecido — redirecionar
  // aqui expulsaria quem tem acesso.
  if (loading) return null;
  if (!podeAcessarCarteira(user?.squadNome, isAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
